// extracted by mini-css-extract-plugin
export default {"button":"BackButton_button__OPfos","icon":"BackButton_icon__YdcXI","title":"BackButton_title__tKrUO"};